import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledLabel,
  StyledBoxModuleRow,
  StyledOrderItem,
  StyledIcon
} from './style';
import {
  StyleWrapIcon,
  StyledBoxInputRow,
  StyledBoxInputRowTwo,
  StyledWrapInputs,
  StyledDropdownInputMonths,
  StyledDropdownInputYears
} from './styleAwards';

import Input from '../../../core/Input';
import { AWARDS } from '../../../../constants/literals/modals';
import { Trash } from '../../../../../assets/images/index';

const AwardItem = ({
  labelMonth,
  labelYear,
  listMonths,
  listYears,
  onChangeInput,
  onClickDelete,
  onClickDown,
  onClickUp,
  onSelectMonth,
  onSelectYear,
  order,
  selectedMonth,
  selectedYear,
  title
}) => (
  <StyledBoxModuleRow>
    <StyledOrderItem
      order={order}
      onClickDown={onClickDown}
      onClickUp={onClickUp}
    />
    <StyledWrapInputs>
      <StyledBoxInputRow>
        <StyledLabel>{AWARDS.NAME}</StyledLabel>
        <Input value={title} onChange={onChangeInput} />
      </StyledBoxInputRow>
      <StyledBoxInputRowTwo>
        <StyledLabel>{AWARDS.DATE}</StyledLabel>
        <StyledDropdownInputMonths
          list={listMonths}
          label={labelMonth}
          selected={selectedMonth}
          onSelect={onSelectMonth}
        />
        <StyledDropdownInputYears
          list={listYears}
          label={labelYear}
          selected={selectedYear}
          onSelect={onSelectYear}
        />
      </StyledBoxInputRowTwo>
    </StyledWrapInputs>
    <StyleWrapIcon>
      <StyledIcon svg={Trash} size="m" onClick={onClickDelete} hover />
    </StyleWrapIcon>
  </StyledBoxModuleRow>
);

AwardItem.propTypes = {
  labelMonth: PropTypes.string,
  labelYear: PropTypes.string,
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  onChangeInput: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  onSelectMonth: PropTypes.func,
  onSelectYear: PropTypes.func,
  order: PropTypes.number,
  selectedMonth: PropTypes.string,
  selectedYear: PropTypes.string,
  title: PropTypes.string
};

AwardItem.defaultProps = {
  labelMonth: '',
  labelYear: '',
  selectedMonth: '',
  selectedYear: '',
  title: ''
};

export default AwardItem;
